import React from 'react';
import PropTypes from 'prop-types'; 
import styled from 'styled-components';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

const Menu = styled.div`
width: 190px;
background-color: #fff;
margin: 0;
padding: 0;
box-shadow: 1px 1px 8px #0000004c;
font-size: 16px;
font-family: 'Trade Gothic LT Std';
color: var(--botc-colour-ink-wineberry);
`;

const ItemContainer = styled.ul`
list-style: none;
margin: 0;
padding: 0;
`;

const MenuItem = styled.button`
border: 0;
width: 100%;
text-align: left;
padding: 12px 12px 12px 32px;
background-color: var(--botc-colour-cream-springwood);
cursor: pointer;
position: relative;
opacity: ${props => props['disabled'] ? '0.5' : '1'};

&:before {
  display: ${props => props.isSelected ? 'block' : 'none'};
  font-family: 'Glyphicons Halflings';
  content: '\\e013';
  font-size: 12px;
  position: absolute;
  top: 15px;
  left: 10px;
}

&:hover {
  color: #fff;
  background-color: var(--botc-colour-cream-straw);
}
`;

const Header = styled.div`
display: flex;
flex-direction: row;
gap: 16px;
margin: 0;
padding: 16px;
cursor: default;
`;

const Icon = styled.img`
`;

const ReactTooltipContainer = styled(ReactTooltip)`
padding: 0 !important;
opacity: 1 !important;


&:after {
  ${props => props.alignTopHack && 'top: 25px !important'};
}
`;

function ActionBarMenu({
  alignTopHack, // offsets top position so menus at top of screen aren't hidden under browser top edge
  iconImgSrc,
  id,
  itemData,
  selectedItem,
  title,
  isDisabled,
}) {

  const menu = () => (
    <Menu>
      <Header>
        <Icon src={iconImgSrc} width="24" height="24" />
        <span>{title}</span>
      </Header>
      <ItemContainer>
        {itemData.map((data, i) =>
          <li key={i}>
            <MenuItem
              isSelected={selectedItem && selectedItem == data.id}
              onClick={() => {data.onClick(data.id)}}
              disabled={isDisabled}
            >
            {data.label}
            </MenuItem>
          </li>
        )}
      </ItemContainer>
    </Menu>
  )

  return (
    <ReactTooltipContainer
      id={id}
      getContent={menu}
      effect="solid"
      // delayHide={500}
      delayUpdate={500}
      place="left"
      border={false}
      type="light"
      globalEventOff="click"
      overridePosition={alignTopHack ? ({left, top}) => { return {left: left, top: top + 70} } : null}
      alignTopHack={alignTopHack}
    />
  );
}

ActionBarMenu.propTypes = {
  alignTopHack: PropTypes.bool,
  iconImgSrc: PropTypes.string,
  id: PropTypes.string,
  itemData: PropTypes.array,
  selectedItem: PropTypes.string,
  title: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default ActionBarMenu;